import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Privilege } from '../../components/catalogs/roles/services/role-privilege';

@Injectable({
  providedIn: 'root'
})
export class PrivilegeService {

  public url: string = environment.urls.baseApiUrl;
  public api: string = this.url + '/Privileges';

  constructor(
    public http: HttpClient
  ) { }

  getAll(): Observable<Privilege[]> {
    return this.http.get<Privilege[]>(this.api);
  }

  getByType(type: number): Observable<Privilege[]> {
    return this.http.get<Privilege[]>(this.api + '/Type/' + type.toString());

  }
}
